import {toast} from '@wandb/weave/common/components/elements/Toast';
import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
import React, {useCallback, useState} from 'react';

import * as ViewHooks from '../../../state/views/hooks';
import * as PanelBankSectionConfigActions from '../../../state/views/panelBankSectionConfig/actions';
import * as PanelBankSectionConfigTypes from '../../../state/views/panelBankSectionConfig/types';
import {isMobile} from '../../../util/panelbankFlow';
import {ImageExportType} from '../../../util/panelExport';
import {getPanelSpec} from '../../../util/panelTypes';
import {usePanelsSharedRefsContext} from '../../Views/contexts/PanelsSharedRefsContext';
import {PanelDeleteMenuItem} from '../common/PanelDeleteMenuItem';
import {PanelOverflowMenu} from '../common/PanelOverflowMenu';
import {useGoToBaseUrl} from '../hooks/hooks';
import {usePanelContext} from '../PanelContextProvider';
import {PanelExportMenu} from '../PanelExportModal/PanelExportMenu';
import {PanelExportModalContainer} from '../PanelExportModal/PanelExportModalContainer';
import {ExportType} from '../types';
import {FullScreenPanelCopyLinkMenuItem} from './FullScreenPanelCopyLinkMenuItem';

type FullScreenPanelOverflowMenuProps = {
  panelBankSectionConfigRef: PanelBankSectionConfigTypes.Ref;
  panelSpec: ReturnType<typeof getPanelSpec>;
};

export const FullScreenPanelOverflowMenu = ({
  panelBankSectionConfigRef,
  panelSpec,
}: FullScreenPanelOverflowMenuProps) => {
  const {panelBankConfigRef, workspaceSettingsRef} =
    usePanelsSharedRefsContext();
  const {panelRef, trackPanelControls} = usePanelContext();
  const goToBaseURL = useGoToBaseUrl();

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const [exportType, setExportType] = useState<ExportType>();
  const [imageExportType, setImageExportType] = useState<ImageExportType>();
  const unsetExportType = useCallback(() => setExportType(undefined), []);

  const deletePanel = ViewHooks.useViewAction(
    panelBankSectionConfigRef,
    PanelBankSectionConfigActions.deletePanel
  );
  const onRemovePanel = useCallback(() => {
    deletePanel(panelRef, panelBankConfigRef, workspaceSettingsRef);
    goToBaseURL();
    toast('Panel deleted');
    trackPanelControls({action: 'Panel deleted'});
  }, [
    deletePanel,
    panelRef,
    panelBankConfigRef,
    workspaceSettingsRef,
    goToBaseURL,
    trackPanelControls,
  ]);

  if (isMobile()) {
    return null;
  }

  return (
    <>
      <PanelExportModalContainer
        exportType={exportType}
        imageExportType={imageExportType}
        panelType={panelSpec.type}
        unsetExportType={unsetExportType}
      />
      <PanelOverflowMenu
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
        buttonSize="md">
        <DropdownMenu.Content align="start" className="mr-12">
          <FullScreenPanelCopyLinkMenuItem />
          <PanelExportMenu
            panelSpec={panelSpec}
            setExportType={setExportType}
            setImageExportType={setImageExportType}
          />
          <DropdownMenu.Separator />
          <PanelDeleteMenuItem onSelect={onRemovePanel} />
        </DropdownMenu.Content>
      </PanelOverflowMenu>
    </>
  );
};
